module.exports = __webpack_public_path__ + "img/Revelio new.d6da2c0a.png";